<template>
    <div id="app" ref="app">
     
   <router-view/>
 
    </div>
</template>

<script>
export default {
    name: "App",
    watch: {
        $route() {
            this.$refs.app.scrollTo(0, 0);
        }
    },
    mounted() {

    // window.onbeforeunload = function (e) {
    //     var storage = window.localStorage;
    //     storage.clear()
    // }
    }
};
</script>


<style>
@import url("style/index.css");
@import url("style/reset.css");
@import "./assets/icon/iconfont.css";
.my-title {
    height: 40px;
    font-size: 20px;
    padding: 0 10px;
    border-left: 5px solid #ff6701;
    margin-bottom: 10px;
    margin-left: -10px;
    line-height: 40px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue